const metrics: [string, string, 'count' | 'decimal' | 'signed'][] = [
  ['P1', 'Volume of employee payroll records in payment', 'count'],
  ['P2', 'Value of employee payroll records in payment file', 'decimal'],
  ['P3', 'Volume of nil payment occurrences', 'count'],
  ['P4', 'Volume of underpayment occurrences', 'count'],
  ['P5', 'Volume of overpayment occurrences', 'count'],
  ['P8', 'Number of overpayments with a recovery plan', 'count'],
  ['P10', 'Value of nil payment occurrences', 'decimal'],
  ['P11', 'Value of overpayment occurrences', 'decimal'],
  ['P12', 'Value of underpayment occurrences', 'decimal'],
  ['P15', 'Value of overpayments with a recovery plan', 'decimal'],
  ['P16', 'Volume of overpayment cases recovered', 'count'],
  ['P17', 'Value of overpayment cases recovered', 'decimal'],
  ['P2P13', 'Volume of Invoices Paid (from the date the invoices were received)', 'count'],
  ['P2P14', 'Value of Invoices Paid (from the date the invoices were received)', 'decimal'],
  [
    'P2P15',
    'Volume of invoices paid (from the date the invoices were received) requiring corrective action',
    'count',
  ],
  [
    'P2P16',
    'Value of invoices paid (from the date the invoices were received) requiring corrective action',
    'decimal',
  ],
  [
    'P2P17',
    'Volume of P2P invoices paid (from the date the invoices were received, excluding public sector)',
    'count',
  ],
  [
    'P2P18',
    'Volume of P2P invoices processed (for non-public sector suppliers) within five (5) working days of the date the invoices were received during the calendar month',
    'count',
  ],
  [
    'P2P19',
    'Volume of P2P invoices processed (for non-public sector suppliers) during the calendar month within thirty (30) calendar days of the date the invoices were received.',
    'count',
  ],
  [
    'P2P20',
    'Total volume of P2P invoices paid (from the date the invoices were received in the period, only for public sector).',
    'count',
  ],
  [
    'P2P21',
    'Volume of P2P invoices paid (to public sector suppliers) during the calendar month within five working days of the date the invoices were received.',
    'count',
  ],
  [
    'P2P22',
    'Volume of P2P invoices paid (to public sector suppliers) during the calendar month within thirty calendar days of the date the invoices were received. Similar to P2P19 but including the public sector',
    'count',
  ],
  ['Q5', 'Number of promoters', 'count'],
  ['Q6', 'Number of detractors', 'count'],
  ['Q10', 'Number of passives', 'count'],
  ['JML1', 'Late transfers out', 'count'],
  ['JML2', 'Total number of transfers out', 'count'],
  ['JML4', 'Total number of transfers in', 'count'],
  [
    'JML9',
    'Time between transfers in being processed and the scheduled payroll cut-off',
    'decimal',
  ],
  [
    'JML10',
    'Number of transfers in processed after the departments or scheduled payroll cut-off',
    'count',
  ],
  ['JML11', 'Lead Time (date of notification minus date of transfers in)', 'signed'],
  ['JML12', 'Number of overpayment cases related to OGD transfers out', 'count'],
  ['JML13', 'Total cost of overpayment cases related to OCG transfers out', 'decimal'],
  ['JML14', 'Late transfers out with less than 10 days notice', 'count'],
  ['R2R1', 'Number of days to close month end', 'decimal'],
  ['E1', 'Number of manual expense claims processed outside ERP/expense system', 'count'],
  ['E2', 'Number of expense claims recorded without proper categorisation', 'count'],
  ['E3', 'Total number of Expense claims', 'count'],
  ['JML15', 'Number of transfers in forms rejected', 'count'],
  ['JML16', 'Number of transfers in forms received', 'count'],
  ['P23', 'Volume of Payroll Overpayment occurrences related to OGD Transfer out', 'count'],
  ['P24', 'Volume of Payroll underpayment occurrences related to OGD Transfer out', 'count'],
  ['P25', 'Volume of Payroll Overpayment occurrences related to OGD Transfer in', 'count'],
  ['P26', 'Volume of Payroll underpayment occurrences related to OGD Transfer in', 'count'],
  ['P20', 'Volume of overpayment cases carried forward at the start of the payslip month', 'count'],
  [
    'P21',
    'Value of overpayments cases carried forward at the start of the payslip month',
    'decimal',
  ],
  ['P22', 'Volume of Payroll overpayment occurrences related to Leavers', 'count'],
  ['P27', 'Volume of Payroll underpayment occurrences related to Leavers', 'count'],
  ['P28', 'Value of Payroll Overpayment occurrences related to transfers out', 'decimal'],
  ['P29', 'Value of Payroll Overpayment occurrences related to leavers', 'decimal'],
  ['R1', 'Time to Hire', 'decimal'],
  ['R2', 'Time to Onboard', 'decimal'],
  ['R3', 'Notice Period', 'decimal'],
  ['R4', 'Time to Fill', 'decimal'],
  ['SR1', 'Volume of Service requests Resolved within 5 working days', 'count'],
  ['SR2', 'Service requests resolved within 6-10 working days', 'count'],
  ['SR3', 'Service requests resolved within 11-20 working days', 'count'],
  ['SR4', 'Service requests resolved in excess of 20 working days', 'count'],
  ['SR5', 'Volume of Service requests resolved', 'count'],
  ['RS1', 'Number of calls answered within maximum target timeframe', 'count'],
  ['RS2', 'Number of eligible calls offered', 'count'],
  ['RS3', 'Number of calls made within 5 minutes of the agreed / scheduled callback slot', 'count'],
  ['RS4', 'Number of call backs scheduled', 'count'],
  ['SA1', 'Total number of contacts through all channels offered', 'count'],
  ['SA2', 'Total number of contacts through digital channels', 'count'],
  ['SA3', 'Total number of contacts through mobile devices', 'count'],
  ['SM1', 'Number of minutes Shared Service Platforms Available', 'count'],
  ['SM2', 'Number of minutes Shared Service Platforms could have been available', 'count'],
  ['SSP1', 'Number of Performance Measures Achieved', 'count'],
  ['SSP2', 'Number of Active Performance Measures', 'count'],
  ['P30', 'Volume of overpayment cases', 'count'],
  ['P31', 'Volume of nil payment occurrences related to OGD Transfer out', 'count'],
  ['P32', 'Volume of nil payment occurrences related to OGD Transfer in', 'count'],
  ['P33', 'Volume of nil payment occurrences related to Leavers', 'count'],
];

export const cpfMetrics = metrics.map(([code, label, format]) => ({
  code,
  label,
  group: code.replace(/\d+$/, ''),
  allowDecimal: format !== 'count',
  allowNegativeNumbers: format === 'signed',
}));
